export default {
  "userVipAdmin.thead.index": "#NO",
  "userVipAdmin.thead.documentId": "DocumentId",
  "userVipAdmin.thead.title": "Level Title",
  "userVipAdmin.thead.levelValue": "Level Value",
  "userVipAdmin.thead.levelAmount": "Level Amount",
  "userVipAdmin.thead.bonusValue": "Bonus Value",
  "userVipAdmin.thead.weeklyBonus": "Weekly Bonus",
  "userVipAdmin.thead.monthlyBonus": "Monthly Bonus",
  "userVipAdmin.thead.withdrawTimesLimit": "WithdrawTimesLimit",
  "userVipAdmin.thead.withdrawAmountLimit": "WithdrawAmountLimit",
  "userVipAdmin.thead.weeklyCashbackConf": "WeeklyCashbackConf",
  "userVipAdmin.thead.monthlyCashbackConf": "MonthlyCashbackConf",
  "userVipAdmin.thead.promotionCashbackConf": "PromotionCashbackConf",
  "userVipAdmin.thead.cashbackAmountType": "CashbackAmountType",
  "userVipAdmin.thead.cashbackValue": "CashbackValue",
  "userVipAdmin.thead.cashbackWithdrawLimit": "CashbackWithdrawLimit",
  "userVipAdmin.thead.cashbackExpire": "CashbackExpire",
  "userVipAdmin.thead.startTime": "StartTime",
  "userVipAdmin.add": "Add",
  "userVipAdmin.edit": "Edit",
  "userVipAdmin.details": "Details",
  "userVipAdmin.delete": "Delete",

  "userVipAdmin.thead.status": "Status",
  "userVipAdmin.thead.createdAt": "CreateTime",
  "userVipAdmin.thead.updatedAt": "ModifyTime",
  "userVipAdmin.thead.action": "Action",
};
